export function formatHMS(ms: number): string {
    if (ms < 0) { 
        ms = 0; 
    }
    const totalSec = Math.ceil(ms / 1_000);
    const min = Math.floor(totalSec / 60);
    const sec = (totalSec % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
}

export function formatS(ms: any): string {
    if (ms < 0) { 
        ms = 0; 
    }
    let sec = 0;
    if (ms) {
        sec = Math.ceil(ms / 1_000);
    }
    return `${sec}`;
}